import SiteNavbar from '../../components/feature/SiteNavbar';
import FooterSection from '../home/components/FooterSection';
import AboutHero from './components/AboutHero';
import AboutStory from './components/AboutStory';
import AboutValues from './components/AboutValues';
import AboutTeam from './components/AboutTeam';
import AboutCTA from './components/AboutCTA';

export default function AboutPage() {
  return (
    <div className="bg-zinc-950 min-h-screen">
      <SiteNavbar />
      <main>
        <AboutHero />
        <AboutStory />
        <AboutValues />
        <AboutTeam />
        <AboutCTA />
      </main>
      <FooterSection />
    </div>
  );
}
